import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button';
import { Field } from '@atlaskit/form';
import TextField from '@atlaskit/textfield';
import { B400 } from '@atlaskit/theme/colors';

import { fontSize } from '@/components/signup/utils/font-size';
import { getSwitchAccountUrl } from '@/components/signup/utils/url';
import { wacToken } from '@/libraries/design/foundations';

export const InputEmail = ({ email }: { email?: string }) => {
	return email ? (
		<div>
			<Field
				isDisabled={true}
				name="email"
				label={
					<span css={labelCss}>
						<FormattedMessage
							id="BxpUiSignup.nameSite.inputEmailLabel"
							defaultMessage="Work email"
						/>
					</span>
				}
			>
				{({ fieldProps }) => (
					<div css={inputCss}>
						<TextField type="text" {...fieldProps} value={email} />
					</div>
				)}
			</Field>
			<Button
				appearance="link"
				css={switchAccountCss}
				onClick={() => {
					window.location.href = getSwitchAccountUrl();
				}}
			>
				<span css={switchAccountInnerCss}>
					<FormattedMessage
						id="BxpUiSignup.nameSite.switchAccountText"
						defaultMessage="Sign in with a different Atlassian account"
					/>
				</span>
			</Button>
		</div>
	) : null;
};

const inputCss = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- needed to style atlaskit input
	['input[disabled]']: {
		fontSize: 16,
		fontWeight: 400,
		fontFamily: wacToken('font.charlie.text'),
		padding: '6px 8px',
	},
});

const labelCss = css({
	color: wacToken('color.primary.black'),
	fontFamily: wacToken('font.charlie.text'),
	fontSize: 14,
	fontWeight: 400,
});

const switchAccountCss = css({
	paddingInline: '0 !important',
});

const switchAccountInnerCss = css({
	fontSize: fontSize.sm,
	color: B400,
});
